import { FinancialInformation, Sifarnik } from "../../model/FinancialInformationType";
import {
    isUserWorking,
    svrhaRacunaOrVrsteTransakcijaHasPrekogranicnoPlacanje,
    userHasNoOtherIncome
} from "./FinancialInformationPage";
import {Country} from "../../model/PersonalInformationType";

const GOTOVINSKA_TRANSAKCIJA_ID = "1";

export const validateField = (
  field: string,
  value: string | Sifarnik | Sifarnik[] | Country[] | null,
  setFieldError: (field: string, message: (string | undefined)) => void,
): boolean => {
    let error: string | undefined = undefined;

    if ((Array.isArray(value) && value.length === 0) || (!value)) {
        error = 'common.validation-error.required'
    }

    setFieldError(field, error);

    return error === undefined;
};

const REQUIRED_FIELDS: (keyof FinancialInformation)[] = [
    "statusZaposlenja",
    "prosjecnaMjesecnaPrimanjaRedovna",
    "izvoriOstalihPrihoda",
    "svrheOtvaranjaRacuna",
    "vrsteTransakcijaNaRacunu",
    "ocekivaniGodisnjiPromet",
    "osnovePriljevaSredstava",
];

const getConditionallyRequiredFields = (values: FinancialInformation): (keyof FinancialInformation)[] => {
    const fields: (keyof FinancialInformation)[] = [];

    if (isUserWorking(values?.statusZaposlenja?.id)) {
        fields.push("vrstaPoslodavca", "pozicijaZaposlenja");
    }

    if (values.izvoriOstalihPrihoda?.length > 0 && !userHasNoOtherIncome(values.izvoriOstalihPrihoda)) {
        fields.push("prosjecanIznosOstalihPrihoda");
    }

    if (values?.vrsteTransakcijaNaRacunu?.some(vrstaTransakcije => vrstaTransakcije.id === GOTOVINSKA_TRANSAKCIJA_ID)) {
        fields.push("prosjecneGotovinskeTransakcije");
    }

    if (svrhaRacunaOrVrsteTransakcijaHasPrekogranicnoPlacanje(values.svrheOtvaranjaRacuna, values.vrsteTransakcijaNaRacunu)) {
        fields.push("drzavePrekogranicnoPlacanje");
    }

    return fields;
};

export const validateForm = (values: FinancialInformation, setFieldError: (field: string, message: (string | undefined)) => void): boolean => {
    let isFormValid = true;

    [...REQUIRED_FIELDS, ...getConditionallyRequiredFields(values)].forEach(field => {
        if (!validateField(field, values[field] ?? null, setFieldError)) {
            isFormValid = false;
        }
    });

    return isFormValid;
}
